import { z } from "zod";

import { VoiceAgentRuntime } from "@/shared/voice-runtime";

export { VoiceAgentRuntime } from "@/shared/voice-runtime";

export const RESPONSE_LATENCY_SPAN_NAME = "valerie.agent_response_latency";

export const RESPONSE_LATENCY_ATTRIBUTE = {
  AgentRuntime: "valerie.response_latency.agent_runtime",
  ClassificationSource: "valerie.response_latency.classification_source",
  FirstForKind: "valerie.response_latency.first_for_kind",
  FirstResponse: "valerie.response_latency.first_response",
  Kind: "valerie.response_latency.kind",
  LatencyMs: "valerie.response_latency.latency_ms",
  PostAcknowledgementWaitMs: "valerie.response_latency.post_acknowledgement_wait_ms",
  TurnId: "valerie.response_latency.turn_id",
} as const;

export enum AgentResponseKind {
  Progress = "progress",
  Substantive = "substantive",
}

export enum ResponseClassificationSource {
  Native = "native",
  Source = "source",
}

export const responseLatencySpanAttributesSchema = z.object({
  [RESPONSE_LATENCY_ATTRIBUTE.AgentRuntime]: z.nativeEnum(VoiceAgentRuntime),
  [RESPONSE_LATENCY_ATTRIBUTE.ClassificationSource]: z.nativeEnum(ResponseClassificationSource),
  [RESPONSE_LATENCY_ATTRIBUTE.FirstForKind]: z.boolean(),
  [RESPONSE_LATENCY_ATTRIBUTE.FirstResponse]: z.boolean(),
  [RESPONSE_LATENCY_ATTRIBUTE.Kind]: z.nativeEnum(AgentResponseKind),
  [RESPONSE_LATENCY_ATTRIBUTE.LatencyMs]: z.number().nonnegative(),
  [RESPONSE_LATENCY_ATTRIBUTE.PostAcknowledgementWaitMs]: z.number().nonnegative().optional(),
  [RESPONSE_LATENCY_ATTRIBUTE.TurnId]: z.string().min(1),
});

export type ResponseLatencySpanAttributes = z.infer<typeof responseLatencySpanAttributesSchema>;
